import { addMonths, addQuarters, addYears } from 'date-fns'
import { DateTime } from 'luxon'
import { ScheduleType } from '../modules/privateOffer/types'

const calculateInstallmentDate = (
  startDate: string,
  flexiblePaymentType: ScheduleType,
  installmentNumber: number
): string => {
  let calculatedDate: Date
  switch (flexiblePaymentType) {
    case ScheduleType.MONTHLY:
      calculatedDate = addMonths(new Date(startDate), installmentNumber)
      break
    case ScheduleType.QUARTERLY:
      calculatedDate = addQuarters(new Date(startDate), installmentNumber)
      break
    case ScheduleType.YEARLY:
      calculatedDate = addYears(new Date(startDate), installmentNumber)
      break
    default:
      calculatedDate = new Date(startDate)
  }
  const formattedDate = DateTime.fromJSDate(calculatedDate).toISODate()
  return formattedDate || calculatedDate.toISOString().split('T')[0]
}

const calculateNumberOfInstallments = (
  flexiblePaymentType: ScheduleType,
  serviceLength?: number
): number => {
  if (serviceLength) {
    switch (flexiblePaymentType) {
      case ScheduleType.MONTHLY:
        return Math.ceil(serviceLength / 1)
      case ScheduleType.QUARTERLY:
        return Math.ceil(serviceLength / 3)
      case ScheduleType.YEARLY:
        return Math.ceil(serviceLength / 12) > 1
          ? Math.ceil(serviceLength / 12)
          : 2
      default:
        return 2
    }
  }
  return 2
}

export const getInstallmentsBasedOnSchedule = ({
  durationInMonths,
  now,
  paymentSchedule,
  tcv,
}: {
  tcv: number
  durationInMonths: number
  paymentSchedule: ScheduleType
  now: string
  variableStartDate?: boolean
}) => {
  const quantityOfInstallments = calculateNumberOfInstallments(
    paymentSchedule || ScheduleType.CUSTOM,
    durationInMonths
  )

  const base = Math.floor(tcv / quantityOfInstallments)
  const remainder = tcv - base * quantityOfInstallments

  return Array.from({ length: quantityOfInstallments }).map((_, index) => {
    return {
      pricePerPaymentInUsd: base + (index === 0 ? remainder : 0),
      chargeDate:
        index === 0
          ? null
          : calculateInstallmentDate(
              now || new Date().toISOString(),
              paymentSchedule || ScheduleType.CUSTOM,
              index
            ),
      isImmediateInstallment: index === 0,
    }
  })
}
